// /utils/HexagonBackground.js

import React, { useEffect, useState } from 'react';

const HexagonBackground = ({ children }) => {
  const [hexagons, setHexagons] = useState([]);

  const generateHexagons = () => {
    const hexWidth = 52; // Width of one hexagon including margins
    const hexHeight = 60; // Full height of the hexagon
    const rows = Math.ceil(window.innerHeight / (hexHeight * 0.75)) + 2; // Adjusted for vertical offset
    const cols = Math.ceil(window.innerWidth / hexWidth) + 2; // Adding extra columns to cover the edges

    const hexagonArray = [];
    for (let row = 0; row < rows; row++) {
      const rowArray = [];
      for (let col = 0; col < cols; col++) {
        rowArray.push(<div key={`${row}-${col}`} className="background-hexagon" />);
      }
      hexagonArray.push(
        <div key={row} className={`background-hexagon-row ${row % 2 === 0 ? 'even' : 'odd'}`}>
          {rowArray}
        </div>
      );
    }
    setHexagons(hexagonArray);
  };

  useEffect(() => {
    generateHexagons();
    window.addEventListener('resize', generateHexagons);
    return () => {
      window.removeEventListener('resize', generateHexagons);
    };
  }, []);

  return (
    <div className="background-hexagon-container">
      <div className="center-gradient"></div>
      {children}
      {hexagons}
    </div>
  );
};

export default HexagonBackground;
